<template>
    <div class="w-full h-full">
        <FormModal
            v-if="openUploadModal"
            @cancel="openUploadModal=false"
            :valid="uploadCSV != undefined"
            @confirm="uploadTransactions()"
            title="Add verified transactions"
            subtitle="Upload the verified transaction csv to the system"
            submitButtonText="Upload"
        >
            <input id="rewardImgUpload" type="file" @change="uploadFile" ref="fileInput" accept=".csv">
        </FormModal>
        <Header
            title="Retailer settlements"
            subText=""
            icon="ShoppingBasket"
        />
        <SubHeader title="Upload transactions"

        subText="">

        </SubHeader>
        <WhiteBox
            title="Cashback transactions"
        >
        <template v-slot:buttons>
            <CustomButton class="w-48 pt-1 pb-2" @click="openUploadModal=true; verification=verificationObject" small text="Submit transactions" type="action"  />
        </template>
            
            <template v-slot:content>
                <EasyDataTable
                    :headers="headersTable1"
                    :items="receivables"
                    :loading="loading"
                    v-model:server-options="serverOptions"
                    :server-items-length="serverItemsLength"
                    :hide-footer="false"
                    :no-hover="true"
                >
                    <template #loading>
                        <div class="p-4 w-full flex justify-center">
                            <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </div>
                    </template>
                    <template #empty-message>
                    <div class="flex justify-center py-4">
                        <div class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                            <p class="text-sm mr-2">No results</p>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                            </svg>
                        </div>
                    </div>
                    </template>
                    <template #header-action="header">
                        <div class="w-full text-right">
                            {{ header.text }}
                        </div>
                    </template>
            
                    <template #item-createdOn="{createdOn}">
                        <p>{{niceDateTime(createdOn) }}</p>
                    </template>

                    <template #item-downloadCSV="verificationObject">
                            <CustomButton class="w-48 pt-1 pb-2" @click="download(verificationObject)" small text="Download CSV" type="default"  />
                    </template>
                    <template #item-received="verificationObject">
                            <CustomButton class="w-48 pt-1 pb-2" v-if="!verificationObject.sentToSupplier" @click="markAsSent(verificationObject)" small text="Mark as sent" type="action"  />
                            <p v-else>Sent to supplier</p>
                    </template>
                    <template #item-upload="verificationObject">
                            <!-- <CustomInput class="w-64 pt-1 pb-2" :hidelabel="true" v-if="!verificationObject.receivedFromSupplier && verificationObject.sentToSupplier" small text="Mark as sent" type="file"  /> -->
                            <CustomButton class="w-48 pt-1 pb-2" v-if="!verificationObject.receivedFromSupplier && verificationObject.sentToSupplier" @click="openUploadModal=true; verification=verificationObject" small text="Submit transactions" type="action"  />
                            <p v-else-if="!verificationObject.sentToSupplier">You need to send the transaction list first</p>
                            <p v-else>Recieved successfully</p>
                    </template>
                </EasyDataTable>
            </template>
        </WhiteBox>
    </div>
</template>

<script setup>
</script>

<script>
import Header from "@/components/Header.vue";
import { DateTime } from 'luxon';
import WhiteBox from "@/components/WhiteBox.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import FormModal from "@/components/modals/FormModal.vue";
import SubHeader from "@/components/SubHeader.vue";

export default {
	name: "manage-publsihers",
	components: {
        Header,
        WhiteBox,
		CustomButton,
        FormModal,
        SubHeader
	},
	props:{
    },

	data() {
		return {
            serverOptions:{
                page: 1,
                rowsPerPage: 25,
            },
            serverItemsLength:undefined,
            uploadCSV: undefined,
            verification: undefined,


            showErrorModal: false,
            showSuccessModal: false,
            openUploadModal: false,
            loading:true,
            headersTable1:[
                { text: "Created on", value: "createdOn"},
                { text: "Download CSV", value: "downloadCSV" },
                
            ],
            receivables:[

            ],
        }
	},
	created(){
        this.getTransactionVerifications(0,25)

	},
	methods: {

        niceDateTime(dateObject) {
			return DateTime.fromMillis(dateObject).toLocaleString(DateTime.DATE_MED)
		},

        uploadFile: function() {
            // const file = event.target.files[0];
			this.uploadCSV = event.target.files[0]
            

        },

        
        async uploadTransactions()
        {

            const formData = new FormData();
            formData.append('multipartFile', this.uploadCSV);

            try {
				const token = localStorage.getItem('token')
                this.loading = true

				const response = await this.$apiFetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/bring-your-own-offer-fulfillment/upload`, {
					method: "POST",
                    body:formData,
					headers: {
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
                    this.openUploadModal = false
				}
				
			} catch (error) {
				return;
			} 
        },

        async getTransactionVerifications(page,size){
			try {
				const token = localStorage.getItem('token')
                this.loading = true

				const response = await this.$apiFetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/bring-your-own-offer-fulfillment?page=${page}&size=${size}`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					var object = await response.json()

                    this.serverItemsLength = object.totalElements
                    this.receivables = object.content  

                    this.loading = false
				}
				
			} catch (error) {
				return;
			}

		},

        async download(transactionVerification) {
            try {
                const token = localStorage.getItem('token');

                this.loading = true;

                const response = await this.$apiFetch(`https://${process.env.VUE_APP_DEFAULT_API}.boogi.io/private/api/client/bring-your-own-offer-fulfillment/${transactionVerification.id}/download`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    const blob = await response.blob(); // Convert the response to a blob
                    const url = window.URL.createObjectURL(blob); // Create a URL for the blob

                    // Create a link element and set its href to the blob URL
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `transaction_verification_boogi_${transactionVerification.id}.csv`); // Set the desired file name

                    document.body.appendChild(link);
                    link.click(); // Programmatically click the link to trigger download

                    document.body.removeChild(link); // Remove the link after the download is triggered
                } else {
                    console.error('Failed to download CSV');
                }
            } catch (error) {
                console.error('Error downloading CSV:', error);
            } finally {
                this.loading = false; // Stop loading
            }
        },
        


	},
	computed: {

	},
	watch: {
        serverOptions: {
            deep: true,
            handler(val){
                     this.getTransactionVerifications(val.page-1,val.rowsPerPage)
                }
    }
	}
}
</script>